import React from 'react';


import {

  useNodesState,
  useEdgesState,
  Node,
  Edge,
} from '@xyflow/react';

import '@xyflow/react/dist/style.css';
import { Brain } from 'lucide-react';
import ProjectCaseStudy from '../components/ProjectCaseStudy';

const initialNodes: Node[] = [
  {
    id: '1',
    type: 'input',
    data: { label: 'Start' },
    position: { x: -350, y: 200 },
    style: {
      background: '#18181b',
      color: 'white',
      border: '1px solid #7c3aed',
      borderRadius: '12px',
      fontSize: '14px',
      fontWeight: 'bold',
    },
  },
  {
    id: '2',
    data: { label: 'Generate Proprietary Data' },
    position: { x: -190, y: 200 },
    style: {
      background: '#18181b',
      color: 'white',
      border: '1px solid #7c3aed',
      borderRadius: '12px',
      fontSize: '12px',
      fontWeight: 'bold',
      padding: '12px',
    },
  },
  {
    id: '3',
    data: { label: 'Fine Tune AI Assistant' },
    position: { x: -10, y: 200 },
    style: {
      background: '#18181b',
      color: 'white',
      border: '1px solid #7c3aed',
      borderRadius: '12px',
      fontSize: '12px',
      fontWeight: 'bold',
      padding: '12px',
    },
  },
  {
    id: '4',
    data: { label: 'Feedback Loop' },
    position: { x: -350, y: 300 },
    style: {
      background: '#18181b',
      color: 'white',
      border: '1px solid #7c3aed',
      borderRadius: '12px',
      fontSize: '12px',
      fontWeight: 'bold',
      padding: '12px',
    },
  },
  {
    id: '5',
    data: { label: 'Generate Tailored Marketing Content' },
    position: { x: -350, y: 450 },
    style: {
      background: '#18181b',
      color: 'white',
      border: '1px solid #7c3aed',
      borderRadius: '12px',
      fontSize: '12px',
      fontWeight: 'bold',
      padding: '12px',
    },
  },
  {
    id: '6',
    data: { label: 'High Output Single Brand Voice' },
    position: { x: 400, y: 350 },
    style: {
      background: '#18181b',
      color: 'white',
      border: '1px solid #7c3aed',
      borderRadius: '50%',
      fontSize: '11px',
      fontWeight: 'bold',
      padding: '20px',
      width: '140px',
      height: '140px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
    },
  },
  {
    id: '7',
    data: { label: 'Continuous Improvement' },
    position: { x: -50, y: 350 },
    style: {
      background: '#18181b',
      color: 'white',
      border: '1px solid #7c3aed',
      borderRadius: '12px',
      fontSize: '12px',
      fontWeight: 'bold',
      padding: '12px',
    },
  },
];

const initialEdges: Edge[] = [
  { id: 'e1-2', source: '1', target: '2', animated: true },
  { id: 'e2-3', source: '2', target: '3', animated: true },
  { id: 'e3-4', source: '3', target: '4', animated: true },
  { id: 'e4-5', source: '4', target: '5', animated: true },
  { id: 'e5-6', source: '5', target: '6', animated: true },
  { id: 'e4-7', source: '4', target: '7', animated: true },
  { id: 'e7-3', source: '7', target: '3', animated: true, style: { stroke: '#F59E0B' } },
];

const ProjectOne = () => {
  const [nodes, , onNodesChange] = useNodesState(initialNodes);
  const [edges, , onEdgesChange] = useEdgesState(initialEdges);

  return (
    <ProjectCaseStudy
      title="Custom GPT Model for Automation"
      tagline="A fine-tuned GPT that generates on-brand marketing content — and keeps getting better."
      icon={<Brain className="w-7 h-7" />}
      context="A marketing team was producing content manually: slow, inconsistent, and off-brand. They needed generation that matched their voice without a writer reviewing every line."
      built="We built a custom GPT model fine-tuned on the client’s proprietary content and brand data. A feedback loop scores output and feeds corrections back in, so quality compounds instead of drifting."
      stack={['OpenAI', 'Fine-tuning', 'Feedback pipeline', 'Content workflows']}
      highlights={['Consistent brand voice', 'Continuous improvement loop', 'Human review optional, not required']}
      nodes={nodes}
      edges={edges}
      onNodesChange={onNodesChange}
      onEdgesChange={onEdgesChange}
    />
  );
};

export default ProjectOne;